<template>
    <!-- 休闲娱乐 1  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[7, 5]" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'entertainment-one',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0-_BG-3.png",
            rightBg: "/img/pay/0--71.png",
        }
    },
    computed: {
        title() {
            return this.$t('entertainment.title');
        },
        subtitle() {
            return this.$t('entertainmentOne.subtitle');
        },
        description() {
            const desc = this.$t('entertainmentOne.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>